import numeral from "numeral";
import {
	isValid,
	format,
	isToday,
	isYesterday,
	isThisYear,
	isBefore,
	isAfter
} from "date-fns";
// import { consumer_fe } from "@lab/meta/consumer";

const consumer_fe = process.env["VUE_APP_CARE_URL"] ||"http://localhost:3000";

export function countPlaces(num: number) {
	const sep = String(23.32).match(/\D/)[0];
	const b = String(num).split(sep);
	return b[1] ? b[1].length : 0;
}

function zeroGeneration(count: number) {
	let i = 0;
	const zeros = [];
	while (i < count) {
		zeros.push("0");
		i++;
	}
	return zeros.join("");
}

export function shortenNumber(num: number) {
	let format = "$0a";
	if (num >= 1000000) {
		// we want to remove trailing zeros from figures like $1.10m
		// calculate the number into a number with a decimal place
		// and parse the float as to remove a trailing zero
		const decimals = countPlaces(num / 1000000);
		// If we have a number with a decimal place we need to format
		// differently.
		if (decimals > 0) {
			// adjust the format string to suit the length of decimal places
			format = `$0.${zeroGeneration(decimals)}a`;
		}
	}
	return numeral(num).format(format);
}

// export function shortenNumber(num: number): string {
// 	return numeral(num).format(
// 		numeral(num).value() <= 1000000 ? "$0a" : "$ 0.00a"
// 	);
// }

export function commaSeparated(arr, useOxfordComma) {
	const listStart = arr.slice(0, -1).join(", ");
	const listEnd = arr.slice(-1);
	const conjunction =
		arr.length <= 1
			? ""
			: useOxfordComma && arr.length > 2
			? ", and "
			: " and ";

	return [listStart, listEnd].join(conjunction);
}

export function distanceFormat(num: number) {
	return numeral(num).format("0,0.0");
}

export function currency(num: number, $fmt = "$0,0") {
	return numeral(num).format($fmt);
}

export function mask(str, $mask = "*", $pattern = /[a-zA-Z0-9]/g) {
	return str.replace($pattern, $mask);
}

export const date_is_before = (date, comparison) => {
	return isBefore(new Date(date), new Date(comparison));
};

export const date_is_after = (date, comparison) => {
	return isAfter(new Date(date), new Date(comparison));
};

export const is_date_set = (date) => {
	return (
		isAfter(new Date(date), new Date("1975-01-01")) && isValid(new Date(date))
	);
};

export const date_local = (date) => {
	return format(new Date(date), "dd/MM/yyyy");
};

export const date_long = (date) => {
	return format(new Date(date), "d MMM yyyy");
};

export const date_server = (date) => {
	return format(new Date(date), "yyyy-MM-dd");
};

export const date_day = (date) => {
	return format(new Date(date), "EEEE do MMM yyyy");
};

export const date_month = (date) => {
	return format(new Date(date), "MMMM yyyy");
};

export const date_time = (date) => {
	date = new Date(date);
	const label = format(date, "d MMM, h:mma");
	return `${
		isToday(date)
			? `Today, ${format(date, "h:mma")}`
			: isYesterday(date)
			? `Yesterday, ${format(date, "h:mma")}`
			: !isThisYear(date)
			? format(date, "d MMM yyyy, h:mma")
			: `${label}`
	}`;
};

export const date_time_object = (date) => {
	const time = format(date, "h:mma");
	const day = `${
		isToday(date)
			? `Today`
			: isYesterday(date)
			? `Yesterday`
			: format(date, "d MMM yyyy")
	}`;
	return { day, time };
};

export const consumerlink = ({
	state,
	slug = null,
	section = "residential-aged-care"
}) => {
	return `${consumer_fe}/${section}/in-${state.toLowerCase()}/${
		slug ? slug : ``
	}`;
};

export const capitalize = (s) => {
	if (typeof s !== "string") return "";
	return s.charAt(0).toUpperCase() + s.slice(1);
};

export function pageName(name: string): string {
	return name
		.split("-")
		.map((segment) => {
			return segment.charAt(0).toUpperCase() + segment.slice(1);
		})
		.join("");
}

export function shortenNumberUnder10k(num: number): string {
	return numeral(num).format("$0,0");
}

const specialChars = {
	à: "a",
	ä: "a",
	á: "a",
	â: "a",
	æ: "a",
	å: "a",
	ë: "e",
	è: "e",
	é: "e",
	ê: "e",
	î: "i",
	ï: "i",
	ì: "i",
	í: "i",
	ò: "o",
	ó: "o",
	ö: "o",
	ô: "o",
	ø: "o",
	ù: "o",
	ú: "u",
	ü: "u",
	û: "u",
	ñ: "n",
	ç: "c",
	ß: "s",
	ÿ: "y",
	œ: "o",
	ŕ: "r",
	ś: "s",
	ń: "n",
	ṕ: "p",
	ẃ: "w",
	ǵ: "g",
	ǹ: "n",
	ḿ: "m",
	ǘ: "u",
	ẍ: "x",
	ź: "z",
	ḧ: "h",
	"·": "-",
	"/": "-",
	_: "-",
	",": "-",
	":": "-",
	";": "-"
};

/* eslint-disable */
export function slugify(text) {
	return text
		.toString()
		.toLowerCase()
		.replace(/\s+/g, "-") // Replace spaces with -
		.replace(/./g, (target) => specialChars[target] || target) // Replace special characters using the hash map
		.replace(/&/g, "-and-") // Replace & with 'and'
		.replace(/[^\w\-]+/g, "") // Remove all non-word chars
		.replace(/\-\-+/g, "-") // Replace multiple - with single
		.replace(/^-+/, "") // Trim - from start of text
		.replace(/-+$/, ""); // Trim - from end of text
}
/* eslint-enable */

export function shortenGender(word: string): string {
	const words = word.split(" or ");
	return words.length > 1
		? words.map((w) => w.split("")[0]).join("/")
		: words.map((w) => w.split("", 1)).toString();
}

export function formatFrequency(word: string): string {
	return word.length
		? "/" + word.toLowerCase().replace("ly", "")
		: "/not specified";
}

// eslint-disable-line
